import React, { useState, forwardRef } from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  ListItemText,
  Typography
} from '@mui/material';

interface TaskStatusDropdownProps {
  value: string;
  onChange: (e: any) => void;
  disabled?: boolean;
  required?: boolean;
}

const TaskStatusDropdown = forwardRef((props: TaskStatusDropdownProps, _ref) => {
    const dropdownList = [
      {
        value: 'OPENED',
        name: 'Opened'
      },
      {
        value: 'CLOSED',
        name: 'Closed'
      },
      {
        value: 'ON_HOLD',
        name: 'On hold'
      }
    ];

    return (
      <FormControl
        fullWidth
        disabled={props?.disabled ? props?.disabled : false}
        className="task-type-dropdown"
      >
        <Typography fontWeight="light" variant="h5" className="input-lable">
          Activity Status
          {props?.required && <span style={{ color: 'red' }}>*</span>}
        </Typography>
        <Select
          sx={{ mt: '4px' }}
          style={{
            fontSize: '12px',
            height: '2rem'
          }}
          displayEmpty
          size="small"
          value={props?.value}
          onChange={(e) => props?.onChange(e)}
        >
          <MenuItem style={{ display: 'none' }} selected disabled value={''}>
            Select Activity Status
          </MenuItem>
          {dropdownList?.length > 0 &&
            dropdownList.map((type, i) => {
              return (
                <MenuItem key={i} value={type.value}>
                  <ListItemText primary={type.name} />
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
    );
  }
);

export default TaskStatusDropdown;
